<template>
  <div>
    <div
      class="relative min-h-[120px] xl:min-h-[290px]"
      data-testid="services-hero-portal"
    >
      <img
        :src="imageDesktop"
        class="absolute top-0 hidden h-full w-full object-cover object-center mix-blend-multiply filter lg:block"
        alt="desktop banner"
        data-testid="hero-image"
      />
      <img
        :src="imageMobile"
        class="absolute top-0 block h-full w-full object-cover object-center mix-blend-multiply filter lg:hidden"
        alt="mobile banner"
      />

      <Breadcrumb
        :menu="breadcrumbStore.items"
        class="absolute left-4 top-5 z-10 mb-6 text-white lg:left-big"
      />

      <div
        class="relative flex h-full flex-col bg-black/45 p-5 px-small pb-12 pt-16 text-white backdrop-blur-sm lg:min-h-[290px] lg:pb-11 lg:pl-big lg:pr-6 lg:pt-16 xl:w-[55%] xl:rounded-br-xl xl:rounded-tr-xl"
      >
        <div class="mb-4 flex flex-row items-center gap-4">
          <Icon v-if="icon" class="size-[50px]" :name="icon" />
          <h3 class="text-2xl font-bold md:text-4xl" data-testid="hero-title">
            {{ title }}
          </h3>
        </div>
        <div class="hidden lg:block">
          <h2 data-testid="hero-subtitle" class="mb-2 text-xl font-bold">
            {{ subTitle }}
          </h2>
          <div>
            <ul
              data-testid="hero-description"
              class="list-inside list-disc text-sm font-semibold"
            >
              <li v-for="item in listItems" :key="item">{{ item }}</li>
            </ul>
          </div>
        </div>
        <ButtonContactUs
          :services="services || []"
          text="Contact Us"
          class="mt-4 text-sm"
        />
      </div>
    </div>
    <div class="h-full px-small pb-1 pt-6 lg:hidden">
      <h2 class="mb-2 text-lg font-bold">
        {{ subTitle }}
      </h2>
      <div>
        <ul class="list-inside list-disc text-sm font-semibold">
          <li v-for="item in listItems" :key="item">{{ item }}</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import Icon from '~/components/common/Icon.vue'
import ButtonContactUs from '~/components/shared/common/ButtonContactUs.vue'
import Breadcrumb from '~/components/shared/navigation/Breadcrumb.vue'
import { useBreadcrumbStore } from '~/stores/breadcrumb'

const props = defineProps<{
  title: string
  subTitle: string
  listItems: string[]
  images: {
    desktop?: string
    mobile?: string
  }
  icon: string
  services: Array<any> | Record<string, any>
}>()

const breadcrumbStore = useBreadcrumbStore()

const imageDesktop = computed(() => {
  return (
    props.images?.desktop ??
    props.images?.mobile ??
    'https://res.cloudinary.com/benchmarkminerals/image/upload/c_fill,q_auto,g_auto,w_auto/v1676580843/assets/forecasts/forecasts-cobalt_kk9zei.png?_i=AA'
  )
})

const imageMobile = computed(() => {
  return (
    props.images?.mobile ??
    props.images?.desktop ??
    'https://res.cloudinary.com/benchmarkminerals/image/upload/c_fill,q_auto,g_auto,w_auto/v1676580931/assets/forecasts/forecasts-cobalt-mobile_yvek1j.png?_i=AA'
  )
})
</script>
